import { createI18n } from "vue-i18n";
import { messages } from "./messages";

export default createI18n({
  legacy: false,
  locale: import.meta.env.VITE_APP_I18N_LOCALE || "en",
  fallbackLocale: import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE || "en",
  silentFallbackWarn: true,
  missingWarn: false,
  fallbackWarn: false,
  messages,
});
